import { get } from 'lodash'

function getConfig (key, defaultValue) {
  return get(window.dataModel, key, defaultValue) || get(window.newBillingConfig, key, defaultValue)
}

export function isEnableEssentialApps () {
  const toggleKey = 'enableEssentialApp'
  return get(window.dataModel, toggleKey, false) || get(window.newBillingConfig, toggleKey, false)
}

export function isProPackageUpdatePhase1 () {
  return getConfig('proPackageUpdatePhase1', false)
}

export function isProPackageUpdatePhase2 () {
  return getConfig('proPackageUpdatePhase2', false)
}

// onboarding page & clips page feature toggle
export const enableLargeMeeting3k5k = get(window.companySetupConfig, 'enableLargeMeeting3k5k', false)
    || get(window.__marvel__, 'enableLargeMeeting3k5k', false)
    || get(window.newBillingConfig, 'enableLargeMeeting3k5k', false)
